var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBeta = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 16,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 15,
  x: 0.5,
  y: 0.5,
  stroke: "#FF6B00",
  rx: 3.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF6B00",
  d: "M7.504 12H4.879V3.422A60 60 0 0 1 7.31 3.34q1.335 0 2.085.574.756.569.756 1.629 0 1.02-1.078 1.611 1.6.557 1.6 2.297 0 1.171-.885 1.864Q8.904 12 7.503 12ZM6.402 4.64v2.057q.352.024.739.024 1.488 0 1.488-1.12 0-.99-1.354-.99-.357 0-.873.03Zm0 3.247v2.836q.464.04.75.04 1.02 0 1.477-.345.463-.345.463-1.148 0-.733-.428-1.067T7.17 7.869q-.223 0-.768.018m7.149-3.117v2.01h2.836v1.294H13.55v2.572h3.89V12h-5.414V3.416h5.479V4.77zm8.8 0V12h-1.523V4.77h-2.73V3.416h7.107V4.77zm7.73 7.23-.628-1.74h-2.941L25.914 12h-1.693l3.422-8.701h.668L31.76 12zm-2.104-6.076-1.032 3.17h2.063z"
})));
export default SvgBeta;